import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

const StyledSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledVehicleSelectionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 144px;
`;

const StyledCircleButton = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 20px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	${(props) =>
		props.$disabled
			? css`
					background-color: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);
					cursor: default;
					pointer-events: none;

					img {
						opacity: 0.25;
					}
			  `
			: css`
					background-color: rgba(255, 255, 255, 0.05);
					border: 1px solid rgba(255, 255, 255, 0.1);

					&:hover {
						background-color: #ffffff;

						img {
							filter: invert(100%);
						}
					}
			  `}

	img {
		width: 12px;
		height: 12px;
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}
`;

const StyledVehicleNameContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto auto;
	gap: 10px;

	& > ${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledColorContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-size: 12px;
		color: #ffffff;
	}

	.circle {
		width: 10px;
		height: 10px;
		border-radius: 10px;
	}
`;

const StyledVINContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ffffff;
	border-radius: 5px;

	${Text} {
		font-size: 12px;
		font-weight: 500;
		color: #000000;

		span {
			font-weight: 400;
			color: rgba(0, 0, 0, 0.5);
		}
	}
`;

const StyledCardsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;
`;

const StyledCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 60px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;

	${Text} {
		color: #ffffff;

		&:first-child {
			font-size: 12px;
			opacity: 0.5;
		}

		&:last-child {
			font-weight: 500;
			font-size: 14px;
			height: 16px;
		}
	}
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > ${Text} {
		font-size: 18px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
`;

const StyledButtonPayContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledCollectionImageWrapper = styled.div`
	width: 300px;
	height: 144px;
	transition:
		opacity 0.3s ease,
		transform 0.3s ease;

	&.vehicle-enter {
		opacity: 0;
		transform: scale(0.8);
	}

	&.vehicle-enter-active,
	&.vehicle-enter-done,
	&.vehicle-exit {
		opacity: 1;
		transform: scale(1);
	}

	&.vehicle-exit-active {
		opacity: 0;
		transform: scale(0.8);
	}
`;

export {
	StyledButtonPayContent,
	StyledButtonsContainer,
	StyledCard,
	StyledCardsContainer,
	StyledCircleButton,
	StyledCollectionImageWrapper,
	StyledColorContainer,
	StyledContainer,
	StyledPrice,
	StyledPriceContainer,
	StyledSection,
	StyledVehicleNameContainer,
	StyledVehicleSelectionContainer,
	StyledVINContainer,
};
